export default (date, locale = 'ru') => date ? new Date(date).toLocaleString(locale, {day: '2-digit', month: '2-digit', year: 'numeric'}) : null